import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  state: {
    selected: {
      site_name: null,
      site_code: null,
      site_email: null,
      site_operational_directorate: null,
      site_phone: null,
      site_postcode: null,
      site_principal_name: null,
      site_principal_network: null,
      site_street: null,
      site_suburb: null,
      site_enrolments: null,
      site_id: null,
      site_parent_site: null,
    },
    results: {
      loading: false,
      error: null,
      data: []
    },
    delegatedSchools: [],
    childSchools: []
  },
  actions,
  mutations,
  getters,
}
